import { Link } from 'react-router-dom';

export function GetStartedButton({
  className = '',
  variant = 'primary',
  children,
}: {
  className?: string;
  variant?: 'primary' | 'white';
  children?: React.ReactNode;
}) {
  const base =
    'inline-flex items-center justify-center rounded-[4px] px-4 py-2.5 text-[15px] font-semibold tracking-[-0.15px] transition-colors';
  const variants = {
    primary: 'bg-[#1d2fb5] text-white hover:bg-[#1728a0]',
    white: 'bg-white text-[#000b57] hover:bg-white/90',
  };
  return (
    <Link to="/get-started" className={`${base} ${variants[variant]} ${className}`}>
      {children ?? 'Get Started'}
    </Link>
  );
}
